import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { IconButton, Button, CardActionArea, Tooltip } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import { blogProps, ReadMoreProps } from '../../context';
import { BlogGallery } from '..';

interface BlogPostProps {
    blog: blogProps;
    link?: boolean;
}

export const BlogPost: React.FC<BlogPostProps> = React.memo(({ blog, link }) => {
    const [readMoreState, setReadMoreState] = React.useState(false);
    const [viewGallery, setViewGallery] = React.useState(false);

    const readMoreStateHandler = React.useCallback(
        () => setReadMoreState(prevReadMoreState => !prevReadMoreState),
        []
    );

    const viewGalleryHandler = React.useCallback(
        () => setViewGallery(prevViewGallery => !prevViewGallery),
        []
    );
    return (
        <div className={`blog__post`}>
            {blog.Gallery && (
                <BlogGallery
                    viewGallery={viewGallery}
                    viewGalleryHandler={viewGalleryHandler}
                    gallery={JSON.parse(blog.Gallery).Gallery}
                />
            )}
            <div className='blog__post__header'>
                <h2 className='blog__post__header__title'>{blog.Title}</h2>
                <p className='blog__post__header__date'>
                    {moment(blog.DatePosted).format('YYYY-MM-DD')}
                </p>
            </div>
            {blog.CoverImage &&
                (blog.Gallery ? (
                    <CardActionArea onClick={viewGalleryHandler}>
                        <div className='blog__post__media'>
                            <img
                                src={blog.CoverImage}
                                alt={blog.Title + ' cover photo'}
                                className='blog__post__media__image'
                            />
                        </div>
                    </CardActionArea>
                ) : (
                    <div className='blog__post__media'>
                        <img
                            src={blog.CoverImage}
                            alt={blog.Title + ' cover photo'}
                            className='blog__post__media__image'
                        />
                    </div>
                ))}
            <div className='blog__post__content'>
                <div className='blog__post__content__description'>
                    <p className='blog__post__content__description__short'>
                        {blog.Description}
                    </p>
                    {readMoreState &&
                        blog.ReadMore &&
                        JSON.parse(blog.ReadMore).map((readMore: ReadMoreProps) => (
                            <div
                                key={readMore.Guid}
                                className='blog__post__content__description__readmore'
                            >
                                {readMore.description && (
                                    <p className='blog__post__content__description__readmore__description'>
                                        {readMore.description}
                                    </p>
                                )}
                                {readMore.list && (
                                    <ul className='blog__post__content__description__readmore__list'>
                                        {readMore.list.map(list =>
                                            list.item ? (
                                                <li
                                                    key={list.item}
                                                    className='blog__post__content__description__readmore__list__item'
                                                >
                                                    {list.item}
                                                </li>
                                            ) : (
                                                <li
                                                    key={list.title}
                                                    className='blog__post__content__description__readmore__list__title'
                                                >
                                                    {list.title}
                                                </li>
                                            )
                                        )}
                                    </ul>
                                )}
                            </div>
                        ))}
                </div>
                <div className='blog__post__content__actions'>
                    {blog.LinkTip ? (
                        <Tooltip title={blog.LinkTip} arrow>
                            <IconButton
                                aria-label='Post Link'
                                size='small'
                                href={blog.Link}
                                target='_blank'
                            >
                                <LinkIcon />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <IconButton
                            aria-label='Post Link'
                            size='small'
                            href={blog.Link}
                            target='_blank'
                        >
                            <LinkIcon />
                        </IconButton>
                    )}
                    {link ? (
                        <Button
                            component={Link}
                            to='https://prispek.co.za/prispek-blogs'
                            size='small'
                            style={{ justifySelf: 'flex-end' }}
                        >
                            Read More
                        </Button>
                    ) : (
                        blog.ReadMore && (
                            <Button
                                size='small'
                                onClick={readMoreStateHandler}
                                style={{ justifySelf: 'flex-end' }}
                            >
                                {readMoreState ? 'Read Less' : 'Read More'}
                            </Button>
                        )
                    )}
                </div>
            </div>
        </div>
    );
});
